import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const UserUpdateModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // superuser role
    superuserRoleId, superuserRoleList, onSuperuserRoleIdChange, superuserRoleIdError,
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Update user'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectUI name='roleId' label='New role' value={superuserRoleId} required={true}
      optionList={superuserRoleList}
      onChange={onSuperuserRoleIdChange} error={superuserRoleIdError}
    />
  </ModalFormUI>

export default UserUpdateModalUI
